export class Attack {
    constructor(archetype, target) {
        this.archetype = archetype
        this.target = target
    }
}